import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import { css } from "styled-components";

navigationDrawerStyles.drawer = {
    size: 300,
    cssOverrides: {
        drawerContent: css`
            margin-top: -2px;
            overflow-x: hidden;
            section {
                outline: 0;
                border: 0;
                a {
                    outline: 0;
                    border: 0;
                }
                nav {
                    outline: 0;
                    border: 0;
                }
            }
        `,
    },
};

navigationDrawerStyles.panelMenu = {
    cssOverrides: {
        wrapper: css`
            outline: 0;
            border: 0;
            > button {
                width: calc(100% - 2px);
                outline: 0;
                border: 0;
            }
        `,
    },
};
